var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white h-full min-h-full min-w-full w-full"},[_c('div',{staticClass:"h-screen overflow-y-auto"},[_c('div',{staticClass:"w-full h-full max-w-screen-xl mx-auto"},[_c('Nuxt')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }